export type Slug = string;
export enum InheritanceStatus {
  IS_PARENT = "parent",
  IS_CHILD = "child",
  NONE = "none",
}
export declare enum ServerEnvironment {
  PRODUCTION = "production",
  STAGING = "staging",
  DEVSHARED = "devshared",
  LOCAL = "local",
  TEST = "test",
}
export enum Size {
  Small = "sizeSmall",
  Medium = "sizeMedium",
  Large = "sizeLarge",
}

export type RequireOnly<T, K extends keyof T> = Pick<T, K> & Partial<Omit<T, K>>;
